import commonFn from '@/commons/commonFunction'

import _ from 'lodash'
export default class {
  constructor (name, api) {
    const me = this
    /**
     * state
     */
    me.state = {
      /**
       * Cấu hình của module
       */
      _config: {
        field: {},
      },
      /**
       * loading
       */
      loading: false,
      /**
       * loading load summary
       */
      loadingSummary: false,
      /**
       * Tổng bản ghi theo paging
       */
      total: 0,
      /**
       * Thông tin tổng
       */
      summary: null,
      /**
       * active data - dùng cho combobox
       */
      items: [],
      /**
       * Không có dữ liệu trong bảng
       * Dùng cờ này để hiển thị mặc hình trống trên danh sách
       */
      empty: false,
      /**
       * Danh sách các cache key sẽ phải xóa đi khi có cập nhật dữ liệu
       */
      cacheKeys: [],
      /**
       * Version dữ liệu ở client để đánh dấu là có thay đổi -> dựa theo món này thay đổi để load lại dữ liệu của combobox
       */
      version: 1,
    }

    /**
     * actions
     */
    me.actions = {
      /**
       * Lấy đường dẫn controller api
       */
      getController () {
        return api.getAPIUrl()
      },

      /**
       * Load danh sách
       */
      async load (context, payload) {
        let res = null
        try {
          context.commit('updateLoading', true)
          res = await api.getList(payload || {})
        } finally {
          context.commit('updateLoading', false)
        }

        if (res) {
          context.commit('setPaging', res)
        }

        return res
      },

      async updateItemQuickFollow (context, payload) {
        context.commit('updateItemQuickFollow', payload)
      },

      /**
       * Load danh sách
       */
      async loadSummary (context, payload) {
        let res = null
        try {
          context.commit('updateLoadingSummary', true)
          res = await api.getList(payload || {})
        } finally {
          context.commit('updateLoadingSummary', false)
        }

        if (res) {
          context.commit('setPaging', res)
        }

        return res
      },

      /**
       * Lấy all bản ghi
       */
      async loadAll (context, payload) {
        let res = null

        try {
          context.commit('updateLoading', true)
          res = await api.getAll(payload || {})
        } finally {
          context.commit('updateLoading', false)
        }

        if (res) {
          context.commit('setAllData', res)
        }

        return res
      },

      /**
       * Load tree
       */
      async loadTree (context, payload) {
        let res = null

        try {
          context.commit('updateLoading', true)
          res = await api.getTree(payload || {})
        } finally {
          context.commit('updateLoading', false)
        }

        if (res) {
          context.commit('setItems', res)
        }

        return res
      },

      /**
       * clearItem
       * @param {*} context
       */
      clearItem (context) {
        context.commit('setItems', [])
      },

      /**
       * Load dữ liệu để thêm/sửa/nhân bản
       * Hàm này sẽ không commit mà return value để binding cho form
       */
      async get (context, payload) {
        const method = 'get' + payload.action
        delete payload.action

        const res = await api[method](payload)
        return res
      },
      /**
       * Thêm mới
       */
      async insert (context, payload) {
        const res = await api.insert(payload)
        if (res) {
          // cập nhật danh sách
          context.commit('insertItem', res)
        }
        return res
      },
      /**
       * Cập nhật
       */ async update (context, payload) {
        const res = await api.update(payload)
        if (res) {
          // cập nhật danh sách
          context.commit('updateItem', res)
        }
        return res
      },
      /**
       * Cập nhật nhiều bản ghi
       */
      async updateMulti (context, payload) {
        const res = await api.updateMulti(payload)
        // TODO Update danh sách
        return res
      },
      /**
       * Xóa
       */
      async delete (context, payload) {
        const res = await api.delete(payload)
        const pasValidate = ['GENERATE_DATA']
        // cập nhật danh sách
        const deleted = []
        if (res) {
          for (let i = 0; i < payload.Models.length; i++) {
            if (
              // eslint-disable-next-line no-prototype-builtins
              res.hasOwnProperty(String(i)) &&
              !pasValidate.find(x => x === res[i]?.Code)
            ) {
              continue
            }

            deleted.push(payload.Models[i])
          }
        }
        context.commit('deleteItems', deleted)
        return res
      },
    }

    /**
     * mutations
     */
    const defaultState = {}
    Object.assign(defaultState, me.state)
    me.mutations = {
      resetState (state) {
        Object.assign(state, defaultState)
      },
      setItems (state, data) {
        state.items = data
      },
      setPaging (state, data) {
        if (data) {
          for (const i in data) {
            const resultValue = data[i]
            switch (i) {
              case 'PageData':
                state.items = resultValue
                break
              case 'Total':
                state.total = resultValue
                break
              case 'Empty':
                state.empty = resultValue
                break
              case 'SummaryData': {
                state.summary = resultValue
                break
              }
            }
          }
        }
      },
      setAllData (state, data) {
        data ??= []
        state.items = data
        state.total = data.length
      },
      addNew (state, item) {
        state.items.push(item)
      },
      updateLoading (state, data) {
        state.loading = data
      },
      updateLoadingSummary (state, data) {
        state.loadingSummary = data
      },
      setItem (state, data) {
        state.item = data
      },
      /**
       * Cập nhật khi thêm bản ghi
       */
      insertItem (state, data) {
        const newItem = data
        state.items = _.concat(newItem, state.items)
        state.total += 1
        state.empty = false

        // xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys)
        }
        state.version++
      },
      /**
       * Cập nhật khi sửa bản ghi
       */
      updateItem (state, data) {
        const keyField = state._config.field.key

        if (keyField) {
          const id = data[keyField]
          for (let i = 0; i < state.items.length; i++) {
            const item = state.items[i]

            if (item[keyField] === id) {
              // Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
              // NCPHUOC 08/07/2022
              if (
                // eslint-disable-next-line no-prototype-builtins
                item.hasOwnProperty('parent_id') &&
                item.parent_id !== data.parent_id
              ) {
                Object.assign(item, data)
                state.items = [...state.items]
              } else {
                Object.assign(item, data)
              }
              break
            }
          }
        }

        // xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys)
        }
        state.version++
      },
      /**
       * Cập nhật khi sửa bản ghi
       * NXCHIEN 07.06.2022
       */
      updateItemQuickFollow (state, payload) {
        const quickField = state._config.field.quickFollow
        const keyField = state._config.field.key
        const data = payload.data
        const value = payload.value

        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            if (keyField && quickField) {
              const id = data[i]
              const objValue = {}
              objValue[quickField] = value

              for (let j = 0; j < state.items.length; j++) {
                const item = state.items[j]

                if (item[keyField] === id) {
                  Object.assign(item, objValue)
                  // break;
                }
              }
            }
          }
        }

        // xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys)
        }
        state.version++
      },

      /**
       * Cập nhật khi xóa bản ghi
       */
      deleteItems (state, items) {
        const keyField = state._config.field.key

        if (keyField) {
          const count = items.length
          const newList = []
          for (let i = 0; i < state.items.length; i++) {
            const item = state.items[i]
            let ignore = false
            for (let k = 0; k < count; k++) {
              const id = items[k][keyField]

              if (item[keyField] === id) {
                ignore = true
                break
              }
            }

            if (!ignore) {
              newList.push(item)
            }
          }

          state.items = newList
          state.total -= count
        }

        // xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys)
        }
        state.version++
      },
    }

    /**
     * getters
     */
    me.getters = {}
    for (const i in me.state) {
      me.getters[i] = function (state) {
        return state[i]
      }
    }
  }
}
